module.exports = __webpack_public_path__ + "static/media/oberflex-aniegret7-1200x2490.f12a0a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegret7-1200x2490.jpg
// module id = 976
// module chunks = 37